import { useState, useCallback } from "react";
import { Auth, useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useDeleteExternal({ iboNumber }, onClose) {
  const { makeAuthedRequest } = Auth.useContainer();
  const [isWaiting, setIsWaiting] = useState(false);
  const [requestId, setRequestId] = useState(0);

  const { logError } = useLogger({ prefix: "DeleteExternalPlugin" });
  const { loading } = useAuthedRequest();
  const refresh = useCallback(() => {
    setRequestId(requestId + 1);
  }, [requestId]);

  const deletePlugin = useCallback(
    async (iboNumber) => {
      setIsWaiting(true);

      return makeAuthedRequest(`/v1/membership/loa/external/${iboNumber}`, {
        method: "DELETE",
      })
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const json = await res.json();
            throw new Error(json.message);
          }
        })
        .catch(logError)
        .finally(() => {
          setIsWaiting(false);
          refresh();
          onClose();
        });
    },
    [logError, refresh, makeAuthedRequest, onClose]
  );

  return {
    loading,
    deletePlugin,
  };
}
